import { DateTime } from "luxon";
import { TypeEnum } from "../retailer-product/types";
import { DataImportantStatusEnum } from "../user/types";

export interface IData {
  _id: string;
  name: string;
  nameJp: string;
  email: string;
  mobile: string;
  orderId: string;
  payment_id: string;
  payment_status: string;
  subTotal: number;
  totalShipmentCapacity: number;
  shipmentCharges: number;
  totalPrice: number;
  taxAmount: number;
  paymentMethod: PaymentMethodType;
  stateId: string;
  state: string;
  status: OrderStatusType;
  importantStatus: DataImportantStatusEnum;
  createdAt: string;
  updatedAt: string;
  invoiceId: string;
}

export interface IFormData {
  _id: string;
  orderId: string;
  status: OrderStatusType;
  payment_status: string;
  subTotal: number;
  totalShipmentCapacity: number;
  shipmentCharges: number;
  totalPrice: number;
  taxAmount: number;
  firstName: string;
  lastName: string;
  japaneseFirstName: string;
  japaneseLastName: string;
  postCode: string;
  state: string;
  district: string;
  streetAddress: string;
  mobileNumber: string;
  email: string;
  companyName: string;
  japaneseCompanyName: string;
  department: string;
  alternateFirstName: string;
  alternateLastName: string;
  alternateJapaneseFirstName: string;
  alternateJapaneseLastName: string;
  alternatePostCode: string;
  alternateState: string;
  alternateDistrict: string;
  alternateStreetAddress: string;
  alternateMobileNumber: string;
  alternateCompanyName: string;
  alternateJapaneseCompanyName: string;
  alternateDepartment: string;
  remarks: string;
  deliveryTimeSlot: string;
  order_items: IOrderItem[];
  paymentMethod: PaymentMethodType;
  importantStatus: DataImportantStatusEnum;
  store: string;
  customerId?: string;
}
export interface IHoldItem {
  orderPackageItemId: string;
}
export interface IOrderItem {
  quantity: number;
  price: number;
  featuredImage: string;
  itemType: TypeEnum;
  shipmentCapacity: number;
  taxRate: number;
  taxAmount: number;
  category: {
    _id: string;
    title: string;
  };
  package?: {
    _id: string;
    title: string;
  };
  product?: {
    _id: string;
    title: string;
  };
  order_package_items: IOrderPackageItem[];
  _id: string;
}

export interface IOrderPackageItem {
  _id: string;
  groupId: string;
  product: {
    _id: string;
    title: string;
  };
  group: {
    _id: string;
    title: string;
  };
  availability?: number;
}

export interface IShippingForm {
  deliveryCompany: string;
  estimatedDeliveryDate: DateTime | null;
  trackingUrl: string;
  trackingNo: string;
}

export enum OrderStatusType {
  NULL = 0,
  PENDING = 1,
  WAITING_FOR_ADMIN = 2,
  PROCESSING = 3,
  SUCCESS = 4,
  CANCELLED = 5,
  FAILED = 6,
  ACCEPTED = 7,
  REJECTED = 8,
  HOLD = 9,
  SHIPPED = 10,
  DELIVERED = 11,
  QUEUED_FOR_UN_HOLD = 12,
  READY_FOR_STORE_PICKUP = 13,
}
export enum PaymentMethodType {
  STRIPE = "stripe",
  CASH_ON_DELIVERY = "cash_on_delivery",
  INVOICE = "invoice_based",
  STORE_PAYMENT = "store_payment",
}

export interface OrderState {
  list: IData[];
  formData: IFormData;
  holdItems: string[];
  loading: boolean;
  buttonLoading: boolean;
  search: string;
  pageNo: number;
  pageSize: number;
  totalRow: number;
  orderBy: string;
  orderDir: string;
  endDate: DateTime | null;
  startDate: DateTime | null;
  shippingForm: IShippingForm;
  filter: OrderStatusType;
}

export type InitialState = OrderState;
